export function getTeacherPricingSummary(modifier) {
    if (!modifier) {
        return 'Default pricing applies (€15/€18/€22 + standard surcharges + €2 performance bonus)';
    }

    const customPrices = [];
    if (modifier.individual_base_price !== 15) customPrices.push(`Individual: €${modifier.individual_base_price}`);
    if (modifier.pair_base_price !== 18) customPrices.push(`Pair: €${modifier.pair_base_price}`);
    if (modifier.group_base_price !== 22) customPrices.push(`Group: €${modifier.group_base_price}`);
    if (modifier.ib_surcharge !== 5) customPrices.push(`IB: €${modifier.ib_surcharge}`);
    if (modifier.special_needs_surcharge !== 3) customPrices.push(`Special Needs: €${modifier.special_needs_surcharge}`);
    if (modifier.lithuanian_surcharge !== 3) customPrices.push(`Lithuanian: €${modifier.lithuanian_surcharge}`);
    if (modifier.performance_bonus !== 2) customPrices.push(`Bonus: €${modifier.performance_bonus}`);

    return customPrices.length > 0 ? customPrices.join(', ') : 'Default pricing applies';
}
